import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

export const integrationsOverview = {
  popover: {
    title: 'Integrations Overview',
    description:
      "Manage all your company's integrations from one place. Easily create, edit, or delete connections with your favorite platforms and tools—let's get started!",
    onNextClick: () => {
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');

      if (actionsToggle) {
        actionsToggle.classList.add('tour-show');

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
